export const sourceTypeIconMap = {
  9: 'icon-chat-voice-ai-line', //智能硬件
  1: 'icon-chat-voice-ai-line', //手动上传音视频
  2: 'icon-draft-line', //CRM跟进记录
  3: 'icon-customer-service-line', //呼叫中心
  10: 'icon-customer-service-line', //AI外呼
  4: 'icon-qiwei-line', //企微单聊
  12: 'icon-qiwei-line', //企微群聊
  5: 'icon-wechat-line', //微信电话
  6: 'icon-wechat-line', //微信聊天
  11: 'icon-wechat-line', //微信群聊
  7: 'icon-smartphone-line', //工作手机电话
  8: 'icon-feishu-line', //飞书群聊
  13: 'icon-patchtalk-ai-line' // 智能贴片
}

export const AllSourceTypeMap = [
  { value: 1, label: '手动上传音视频', key: 'enableAssistant' },
  { value: 9, label: '智能硬件', key: 'enableHardware' },
  { value: 2, label: 'CRM跟进记录', key: 'enableFollow' },
  { value: 3, label: '呼叫中心', key: 'enableCallCenter' },
  { value: 7, label: '工作手机电话', key: 'enableYkMobile' },
  { value: 6, label: '微信单聊', key: 'enableYkMobile' },
  { value: 11, label: '微信群聊', key: 'enableYkMobile' },
  { value: 5, label: '微信电话', key: 'enableYkMobile' },
  { value: 4, label: '企微单聊', key: 'sessionArchive' },
  { value: 12, label: '企微群聊', key: 'sessionArchive' },
  { value: 8, label: '飞书群聊', key: 'enableFeiShuGroup' },
  { value: 10, label: 'AI外呼', key: 'enableAiHkh' }
]
